import { action } from 'easy-peasy';
import { IActionSetMoreTriageRequests } from '../types';
import { mergeUniqueBy } from '~/utils/pagination';

const setMoreTriageRequests: IActionSetMoreTriageRequests = action((state, payload) => {
  const hasMore = state.pagination.itemsPerPage === payload.requests.length;

  const newItems = mergeUniqueBy(
    state.triageRequests.requests,
    payload.requests,
    item => item.noteId,
  );

  state.triageRequests.total = payload.total;
  state.triageRequests.requests = [...newItems];
  state.pagination.page += 1;
  state.pagination.hasMore = hasMore;
});

export default setMoreTriageRequests;
